export default __webpack_public_path__ + "static/media/Digital-Patreon-Wordmark_Black.f179a4bd.png";